{
    "OninboundalertingPara": "pode ativar alarmes quando as chamadas recebidas alertam por muito tempo.",
    "OntalktimePara": "Também pode ativar alarmes quando qualquer chamada atingir um limite de tempo de conversação.",
    "OninboundalertingLabel": "No alerta de entrada sobre:",
    "OntalktimeLabel": "Sobre o tempo de conversação:",
    "OninboundalertingEnabledHiddenlabel": "A Definição \"Tempo de Alerta de Entrada Excedido\" está Ativada?",
    "OntalktimeEnabledHiddenlabel": "A Definição \"Tempo de Conversação Excedido\" está Ativada?",
    "OninboundalertingPlaceholder": "15s",
    "OntalktimePlaceholder": "5m 0s",
    "CallStateThresholds_SectionHeader": "Limites de estado de chamada",
    "NAME": "CallStateThresholds"
}